import PaymentInvoiceSkipped from './PaymentInvoiceSkipped.component';

export default PaymentInvoiceSkipped;